<template>
  <div id="app">
    <page-bar
      ref="pageBar"
      active-color="#209CFF"
      :bg-color="barConf.bgColor"
      :blank-show="barConf.blankShow"
      login-color="#209CFF"
    />
    <!-- 路由占位符 -->
    <router-view ref="routeview" />
    <page-footer />
  </div>
</template>

<script>
import pageBar from '@/components/common/bar.vue'
import pageFooter from '@/components/common/footer.vue'
export default {
  name: 'Layout',
  components: {
    pageBar,
    pageFooter,
  },
  data() {
    return {
      barType: 'default',
      scrollTop: 0,
    }
  },
  computed: {
    pageBarHeight() {
      return this.$refs.pageBar ? parseInt(this.$refs.pageBar.barHeight) : 0
    },
    barConf() {
      const conf = {}
      switch (this.barType) {
        // case 'course': {
        //   // let pageBarHeight = this.$refs.pageBar
        //   //   ? parseInt(this.$refs.pageBar.barHeight)
        //   //   : 0
        //   conf.blankShow = false
        //   conf.bgColor = this.scrollTop > 0 ? '#fff' : ''
        //   break
        // }
        default: {
          conf.blankShow = true
          conf.bgColor = '#fff'
          break
        }
      }
      return conf
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(e) {
        this.$nextTick(() => {
          this.barType = e.meta.barType || 'default'
        })
      },
    },
  },
  mounted() {
    window.addEventListener('scroll', this.setScrollTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.setScrollTop)
  },
  methods: {
    setScrollTop() {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
    },
  },
}
</script>

<style lang="scss"></style>
